export const LoadingIndicator = () => null;
